import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { PrivaLocalizationModule } from '@priva/localization';

import { DialogLoaderComponent } from './dialog-loader/dialog-loader.component';
import * as fromLoading from './state/reducers';

@NgModule({
    imports: [
        CommonModule,
        PrivaLocalizationModule,
        StoreModule.forFeature(fromLoading.loadingFeatureKey, fromLoading.reducers),
        DialogLoaderComponent,
    ],
    exports: [DialogLoaderComponent],
})
export class LoadingModule {}
